import EditIcon from "@mui/icons-material/Edit";
import {
  AdminItemsRow,
  AdminItemsContainer,
  AdminItemContainer,
} from "../../admin.styled";
import { useState } from "react";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { ConfirmationDialog } from "core/components/global/confirmationDialogBox/confirmationDialog";
import {
  IconButton,
} from "@mui/material";
import {
  deleteConversationByID
} from "modules/agentMySecurity/services/embeddingsService";
import { Toast } from "core/components/global/toast/toast";

export function AdminConversationRow({ conversation, onDelete }) {
    const [openRow, setRowOpen] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const handleDeleteClick = () => {
        setOpenDialog(true);
    };


    const handleDelete = async () => {
        try {
            setIsDeleting(true);
            const response = await deleteConversationByID(conversation.conversationId);
            
            if (response !== null) {
                onDelete(conversation._id);
                Toast("User deleted successfully", "success");
            } else {
                Toast("Failed to delete user", "error");
            }
        } catch (error) {
            console.error("Delete error:", error);
        } finally {
            setIsDeleting(false);
            setOpenDialog(false);
        }
    };

    return (
        <AdminItemsRow>
            <div className="unexpanded-row-container">
                <div className="row-items" onClick={() => setRowOpen(!openRow)}>
                    <p className="row-item">{conversation._id}</p>
                    <p className="row-item">{conversation.model}</p>
                    <p className="row-item">{conversation.createdAt}</p>
                </div>
                <div className="row-buttons">
                    <IconButton onClick={handleDeleteClick}>
                        <DeleteOutlineOutlinedIcon fontSize="small" color="error"/>
                    </IconButton>
                </div>
            </div>

            {openRow && (
                <AdminItemsContainer>
                    <AdminItemContainer className="d-flex flex-row">
                        <strong>ID:</strong>
                        <p className="ps-1">{conversation._id}</p>
                    </AdminItemContainer>
                    <AdminItemContainer className="d-flex flex-row">
                        <strong>Conversation Title:</strong>
                        <p className="ps-1">{conversation.conversationTitle}</p>
                    </AdminItemContainer>
                    <AdminItemContainer className="d-flex flex-row">
                        <strong>Model:</strong>
                        <p className="ps-1">{conversation.model}</p>
                    </AdminItemContainer>
                    <AdminItemContainer className="d-flex flex-row">
                        <strong>Created At:</strong>
                        <p className="ps-1">{conversation.createdAt}</p>
                    </AdminItemContainer>
                    <AdminItemContainer className="d-flex">
                        <strong>Messages</strong>
                        <p className="ps-1">{conversation.messages[0].content}</p>

                        {conversation.messages.map((conversation) => (
                            <div className="ps-1">{conversation.content}</div>
                        ))}
                    </AdminItemContainer>
                </AdminItemsContainer>
            )}

            <ConfirmationDialog
                open={openDialog}
                title="Confirm Delete"
                message={`Are you sure you want to delete this message ${conversation._id}"?`}
                isLoading={isDeleting}
                onClose={() => setOpenDialog(false)}
                onConfirm={handleDelete}
            />

        </AdminItemsRow>
    );
}